import {
  OpenAPI,
  RejectionEmailService
} from "../api/generated"

OpenAPI.BASE = import.meta.env.VITE_API_ENDPOINT

export const postRejEmailContent =
  RejectionEmailService.createRejectionEmailRejectionEmailRejectionemailPost

export const uploadLogo = RejectionEmailService.updateRejectionEmailBrandingRejectionEmailRejectionemailBrandingPut